export const DISPOSABLE_SIGNUP_EMAIL_MESSAGE =
  "Use um e-mail permanente. Endereços temporários não são aceitos.";

export const SIGNUP_EMAIL_NO_MX_MESSAGE =
  "Esse domínio de e-mail não recebe mensagens. Use outro endereço.";
